import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MenuComponent } from 'src/app/components/menu/menu.component'
import { SidebarService } from 'src/app/services/sidebar.service'

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterModule, MenuComponent],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss',
})
export class AppLayoutComponent {
  constructor(private readonly sidebarService: SidebarService) {}

  protected get isCollapsed(): boolean {
    return this.sidebarService.collapsed()
  }

  protected openMobile(): void {
    return this.sidebarService.openMobile()
  }
}
